.row {
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 8px;
  gap: 12px;
  border-bottom: var(--border-gray-70);

  &.hideBorder {
    border-bottom: none;
  }

  &:hover {
    background-color: var(--color-gray-background);
  }
}

.name {
  @include typography-regular-14;

  flex: 1;
  color: var(--color-gray-black);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saveButton {
  padding: 4px !important;
  flex-shrink: 0;
}

.saveIcon {
  width: 16px;
  height: 16px;
}
